import { useCallback, useEffect, useRef, useState } from 'react';
import { obtenerDatosSeguridad, obtenerEmpleado, obtenerProyecto, obtenerPuesto, obtieneDatosControl, registrarObservacion, validarSeguridad } from '../../services/Monitor/MonitorService';
import { creaComunicaConfigDetalle } from '../../services/HorarioTurno/TurnoService';
import { RadioButton } from 'primereact/radiobutton';

const useMonitorCom = () => {
    const [loadProyecto, setLoadProyecto] = useState(true);
    const [proyecto, setProyecto] = useState(null);
    const [lstProyecto, setLstProyecto] = useState([]);

    const [loadPuesto, setLoadPuesto] = useState(false);
    const [puesto, setPuesto] = useState(null);
    const [lstPuesto, setLstPuesto] = useState([]);

    const [loadEmpleado, setLoadEmpleado] = useState(false);
    const [empleado, setEmpleado] = useState(null);
    const [lstEmpleado, setLstEmpleado] = useState([]);

    const [colorSeg, setColorSeg] = useState('');
    const [lstColorSeg, setLstColorSeg] = useState([]);
    const [disabledSelect, setDisabledSelect] = useState(false);
    const [inhabControl, setInhabControl] = useState(true);
    const [cargaDetalles, setCargaDetalles] = useState(false);

    const [codigoSeg, setCodigoSeg] = useState('');
    const [fraseSeg, setFraseSeg] = useState('');
    const [fraseValida, setFraseValida] = useState('');
    const [observacion, setObservacion] = useState('');

    const [procesando, setProcesando] = useState(false);

    const [turno, setTurno] = useState('');

    const [lstComunica, setLstComunica] = useState([]);
    const [horaSelected, setHoraSelected] = useState();
    const [horaDetalle, setHoraDetalle] = useState();
    const [horaDetalleId, setHoraDetalleId] = useState();

    const [activado, setActivado] = useState(true);
    //const activadoRef = useRef(activado);

    const [lstComunicaTotal, setLstComunicaTotal] = useState([]);
    const [lstEventosCerca, setLstEventosCerca] = useState([]);
    const [lstEventosPen, setLstEventosPen] = useState([]);

    const [esReemplazo, setEsReemplazo] = useState('');
    const [mostrarObs, setMostrarObs] = useState(false);
    const [evtTurno, setEvtTurno] = useState(null);
    const [procesaObs, setProcesaObs] = useState(false);

    const [infoAdiconal, setInfoAdiconal] = useState();

    const[cargaPendientes, setCargaPendientes] = useState(false)

    const toast = useRef(null);

    useEffect(() => {
        const cargarProyecto = async () => {
            try {
                const datos = await obtenerProyecto();
                setLstProyecto(datos);
                setLoadProyecto(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        cargarProyecto();
    }, []);

    useEffect(() => {
        const cargarPuesto = async () => {
            if (proyecto) {
                setLoadPuesto(true);
                setInfoAdiconal('');
                try {
                    const datos = await obtenerPuesto(proyecto.id);
                    setLstPuesto(datos);
                } catch (error) {
                    console.error(error.message);
                }
                setLoadPuesto(false);
            }
        };
        cargarPuesto();
    }, [proyecto]);

    useEffect(() => {
        const cargarEmpleado = async () => {
            if (puesto) {
                setLoadEmpleado(true);
                try {
                    const datos = await obtenerEmpleado(puesto.id);
                    //console.log('kk00:', datos)
                    setLstEmpleado(datos);
                    // se puede seleccionar un Turno ??
                    for (const item of datos) {
                        if (item.isActive === true) {
                            setEmpleado(item);
                            if (item.turnoPadre !== null) {
                                setEsReemplazo('Empleado Reemplazo');
                            } else {
                                setEsReemplazo('');
                            }
                        }
                    }
                } catch (error) {
                    console.error(error.message);
                }
                setLoadEmpleado(false);
            }
        };
        cargarEmpleado();
    }, [puesto]);

    useEffect(() => {
        //const [lstColorSeg, setLstColorSeg] = useState([]);
        const cargaColores = async () => {
            //
            if (empleado) {
                setInhabControl(true);
                try {
                    //const datos = await obtenerColores(empleado.empleadoId);
                    const datos = await obtenerDatosSeguridad(empleado.empleadoId);
                    setLstColorSeg(datos?.coloresSeg);
                    setFraseSeg(datos.fraseSeg);
                    setInhabControl(false);
                } catch (error) {
                    console.error(error.message);
                    toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Empleado sin Datos de Seguridad' });
                    setCodigoSeg('');
                    setFraseSeg('');
                    setLstColorSeg([]);
                }
                setTurno(`${empleado.horarioSigla} - ${empleado.horarioNombre}: ${empleado.horarioLiteral}`);
            }
        };
        cargaColores();
    }, [empleado]);

    // funcion para mostrar los eventos mas proximos
    /*useEffect(() => {
        let timeOutId;
        let intervaloId;
        const verificaHora = async () => {
            if (!activadoRef.current) {
                console.log('Krono Cancelado');
                return;
            }
            //Buscar los datos
            console.log('KWKWK: Crono Ejecutandose');
            const [datosCer, datosPen] = await obtieneDatosControl();
            if (datosCer !== null) {
                setLstEventosCerca(datosCer);
            }
            if (datosPen !== null) {
                setLstEventosPen(datosPen);
            }
        };

        if (activado) {
            // programar para dentro de 30
            timeOutId = setTimeout(() => {
                if (activadoRef.current) {
                    //solo si esta activado
                    verificaHora();
                    // programar cada minuto
                    intervaloId = setInterval(verificaHora, 60000);
                }
            }, 30000);

            return () => clearInterval(intervaloId);
        } else {
            if (timeOutId) clearTimeout(timeOutId);
            if (intervaloId) clearInterval(intervaloId);
        }
        //limpieza
        return () => {
            if (timeOutId) clearTimeout(timeOutId);
            if (intervaloId) clearInterval(intervaloId);
        };
    }, [activado]);*/

    // Effect para mostrar los eventos cercanos y vencidos
    const timerRef = useRef(null);
    const cargandoRef = useRef(false);
    const activadoRef = useRef(activado);

    const realizarCarga = useCallback(async () => {

        // si hay una peticion en curso o si no esta activado no hace nada
        if (cargandoRef.current || !activadoRef.current) return;

        // poner candado
        cargandoRef.current = true;

        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        //console.log('EJECUTANDO PETICIÓN (Timer o Manual)');

        try {
            setCargaPendientes(true)
            const resultado = await obtieneDatosControl();
            if (activadoRef.current && resultado && Array.isArray(resultado)) {
                const [datosCer, datosPen] = resultado;
                if (datosCer !== null) setLstEventosCerca(datosCer);
                if (datosPen !== null) setLstEventosPen(datosPen);
            }
        } catch (error) {
            console.error('Error en el ciclo de monitoreo', error);
        } finally {
            setCargaPendientes(false)
            // se libera el candado
            cargandoRef.current = false;
            if (activadoRef.current) {
                // se programa la siguiente carga
                timerRef.current = setTimeout(realizarCarga, 15000);
            }
        }
    }, []);

    useEffect(() => {
        activadoRef.current = activado;

        if (activado) {
            //console.log ('monitor activado')
            realizarCarga();
        } else {
            //console.log ('monitor NO esta activado')
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        }
    }, [activado, realizarCarga]);

    // limpieza al desmontar el componente
    useEffect(()=>{
        return ()=> {
            //console.log ('Desmontando el componente');
            activadoRef.current = false;
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }
    }, [])

    const handleRefrescarManual = () => {
        if (!activado) return;
        realizarCarga();
    };

    const sacarElementosLista = (codigoSalida) => {
        //console.log('QUITANDO....', codigoSalida)
        if (codigoSalida && lstEventosPen && lstEventosPen.length ) {
            const lstFiltro = lstEventosPen.filter (item => item.comunicaConfigDetalleId !== codigoSalida)
            setLstEventosPen(lstFiltro)
        }
        if (codigoSalida && lstEventosCerca && lstEventosCerca.length ) {
            const lstFiltro = lstEventosCerca.filter (item => item.comunicaConfigDetalleId !== codigoSalida)
            setLstEventosCerca(lstFiltro)
        }
    }

    /*const buscaPendientes = async () => {
        try {
            //console.log('Buscando PENDIENTES.......')
            setCargaPendientes(true)
            setLstEventosPen([])
            setLstEventosCerca([])
            const resultado = await obtieneDatosControl();
            if (resultado && Array.isArray(resultado)) {
                const [datosCer, datosPen] = resultado;
                if (datosCer !== null) setLstEventosCerca(datosCer);
                if (datosPen !== null) setLstEventosPen(datosPen);
            }
        } catch (error) {
            console.error('Error en el ciclo de monitoreo', error);
        } finally {
            setCargaPendientes(false)
        }
    };

    useEffect ( ()=> {
        buscaPendientes();
    }, [])*/

    const handleCLick = async () => {
        if (codigoSeg && fraseValida && colorSeg && horaDetalleId) {
            const segurDatos = {
                personaId: empleado.empleadoId,
                turnoId: empleado.turnoId,
                codigoSeg: codigoSeg,
                fraseVal: fraseValida === 'fraseValida',
                colorSeg: colorSeg.codigoColor,
                observacion: observacion,
                comunicaConfigDetalleId: horaDetalleId,
                horaConfigDetalle: horaDetalle
            };
            setProcesando(true);
            setDisabledSelect(true);
            setInhabControl(true);
            try {
                const response = await validarSeguridad(segurDatos);
                // si todo bien
                if (response.observacion.substring(0, 6) === 'ERROR:') {
                    //toast.current.show({ severity: 'warn', summary: 'Warning', detail: response.observacion.substring(6) });
                    // mostrar pantalla de observacion
                    setEvtTurno(response);
                    //setObservacion(response.observacion.substring(6));
                    setObservacion('');
                    setMostrarObs(true);
                } else {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: response.observacion + '. En un momento se actualizan las Listas' });
                }
                setCodigoSeg('');
                setFraseSeg('');
                setColorSeg('');
                setDisabledSelect(false);
                setProyecto(null);
                setPuesto(null);
                setEmpleado(null);
                setTurno('');
                setLstComunica([]);
                setEsReemplazo('');
                // se manda ejecutar el refresco manual
                //handleRefrescarManual();
                if (!activado) {
                    sacarElementosLista(horaDetalleId)
                }
            } catch (error) {
                console.error(error.message);
            } finally {
                setProcesando(false);
                // refrescar el Pendientes.
                //buscaPendientes()
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Los campos Codigo Seguridad, si la Frase es valida el color de seguridad y la Observacion deben tener valores.' });
        }
    };

    useEffect(() => {
        const cargaConfComunica = async () => {
            if (empleado) {
                const objData = {
                    turnoId: empleado.turnoId,
                    horarioDetalleId: empleado.horarioDetId
                };
                try {
                    // trata de cargar detalles
                    setCargaDetalles(true);
                    const response = await creaComunicaConfigDetalle(objData);
                    //console.log('ZZXX00:', response)
                    setLstComunicaTotal(response);
                    //const fechaAhora = new Date();   //antes
                    const fechaAhoraMs = new Date().getTime(); // es mas seguro comparar Ms: Milisegundos
                    //const lstTempo = response.filter((item) => item.fechaOrden <= fechaAhora);
                    const lstTempo = response.filter((item) => {
                        const fechaItemMs = new Date(item.fechaOrden).getTime();
                        return fechaItemMs <= fechaAhoraMs; // comparacion entre numeros es mas segura
                    });
                    setLstComunica(lstTempo);
                } catch (error) {
                    console.error('Error al obtener Configuracion de Ronda');
                    setLstComunica([]);
                } finally {
                    setCargaDetalles(false);
                }
            }
        };
        cargaConfComunica();
    }, [empleado]);

    useEffect(() => {
        if (lstComunica.length > 0) {
            const ultimoElemento = lstComunica[lstComunica.length - 1];
            //console.log('ZJJ0:', lstComunica)
            setHoraSelected(ultimoElemento.comunicacionConfigDetalleId);
            setHoraDetalle(ultimoElemento.horaComunica);
            setHoraDetalleId(ultimoElemento.comunicacionConfigDetalleId);
        }
    }, [lstComunica]);

    const pintaFila = (filaData) => {
        const ahora = new Date();
        if (filaData.fechaOrden >= ahora) {
            return 'bg-red-100';
        }
    };

    const handleChangeRadio = (e, fila) => {
        // onChange={(e) => setHoraSelected(e.value)}
        setHoraSelected(e.value);
        setHoraDetalle(fila.horaComunica);
        setHoraDetalleId(fila.comunicacionConfigDetalleId);
    };

    const columnaEleccion = (filaData) => {
        const ahora = new Date();
        return (
            <div>
                <RadioButton
                    inputId={`rb-${filaData.comunicacionConfigDetalleId}`}
                    name="hora-grupo"
                    value={filaData.comunicacionConfigDetalleId}
                    onChange={(e) => handleChangeRadio(e, filaData)}
                    checked={horaSelected === filaData.comunicacionConfigDetalleId}
                    disabled={filaData.fechaOrden >= ahora}
                />
            </div>
        );
    };

    const handleChangeEmpleado = (evt) => {
        //console.log ('zz01:', evt.value)
        //quitando la validacion porque los puestos dinamicos no tienen horariodetid
        /*if (evt.value.horarioDetId === 0) {
            const mensajeModal = `Horario: ${evt.value.horarioSigla} del empleado no tiene detalles. Asigne Detalle a Horario ${evt.value.horarioSigla}`;
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: mensajeModal });
            return;
        }*/
        setEmpleado(evt.value);
        evt.value.turnoPadre !== null ? setEsReemplazo('Empleado Reemplazo') : setEsReemplazo('');
    };

    const handleClickObservacion = async (objEventoTurno) => {
        if (observacion) {
            setProcesaObs(true);
            const objPaModificar = {
                comunicaRondaId: objEventoTurno.comunicaRondaId,
                codigoPersonaValido: objEventoTurno.codigoPersonaValido,
                frasePersonaValido: objEventoTurno.frasePersonaValido,
                colorPersonaValido: objEventoTurno.colorPersonaValido,
                observacion: observacion
            };
            try {
                const response = await registrarObservacion(objPaModificar);
                if (response) {
                    toast.current.show({ severity: 'success', summary: 'Registrado', detail: 'Se ha registrado la Observación' });
                    setMostrarObs(false);
                    setProcesaObs(false);
                }
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se ha podido registrar la Observacion' });
            }
        } else {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar el campo Observacion' });
        }
    };

    const handlePuestoChange = (evt) => {
        setPuesto(evt.value);
        //console.log('JJ09', evt.value)
        setInfoAdiconal(evt.value.infoAdicional);
    };

    return {
        loadProyecto,
        proyecto,
        lstProyecto,
        loadPuesto,
        puesto,
        lstPuesto,
        loadEmpleado,
        empleado,
        lstEmpleado,
        lstColorSeg,
        colorSeg,
        inhabControl,
        toast,
        procesando,
        codigoSeg,
        fraseSeg,
        setProyecto,
        setCodigoSeg,
        setFraseSeg,
        handleCLick,
        setEmpleado,
        setColorSeg,
        setPuesto,
        turno,
        setTurno,
        fraseValida,
        setFraseValida,
        observacion,
        setObservacion,
        lstComunica,
        pintaFila,
        columnaEleccion,
        disabledSelect,
        cargaDetalles,
        esReemplazo,
        handleChangeEmpleado,
        lstEventosCerca,
        lstEventosPen,
        activado,
        setActivado,
        mostrarObs,
        setMostrarObs,
        evtTurno,
        handleClickObservacion,
        infoAdiconal,
        handlePuestoChange, 
        cargaPendientes
    };
};

export default useMonitorCom;
